<template>
  <ButtonGroup :primary-button-text="tr(labelPrimaryButton)"
               :primary-button-icon-name="primaryButtonIconName"
               :secondary-button-text="tr(labelSecondaryButton)"
               :secondary-button-icon-name="secondaryButtonIconName"
               @primary-button-click="$emit('ok')"
               @secondary-button-click="$emit('cancel')">
  </ButtonGroup>
</template>

<script>
  import { translator } from '~/zf/frontend/common/mixins';
  import ButtonGroup from './ButtonGroup.vue';

  export default {
    name: 'ConfirmationModalButtonGroup',
    compatConfig: {
      MODE: 3,
    },
    components: {
      ButtonGroup,
    },
    mixins: [translator],
    props: {
      labelPrimaryButton: {
        default: 'default.TX_YES',
      },
      primaryButtonIconName: {
        type: String,
        default: 'checkmark',
      },
      labelSecondaryButton: {
        default: 'default.TX_NO',
      },
      secondaryButtonIconName: {
        type: String,
        default: 'cancel-circle',
      },
    },
    emits: ['ok', 'cancel'],
  };
</script>
